import angular from 'angular'
import { realUrl } from '../../../../../build/config'

export default class buildTaskModalCtr {
  constructor(
    $scope,
    $uibModalInstance,
    selectedRows,
    logger,
    allApplyPeriod,
    httpRequest
  ) {
    $scope.submit = {
      sign: '5',
    }
    $scope.selectedRows = selectedRows
    $scope.allApplyPeriod = allApplyPeriod
    // 所有纳税人类型
    $scope.taxTypeListId = []
    for (let i = 0; i < $scope.selectedRows.length; i++) {
      $scope.taxTypeListId.push($scope.selectedRows[i].id)
    }
    $scope.submit.taxId = $scope.taxTypeListId.map(String)
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
    $scope.ok = function ok() {
      submit()
    }
    // 确定提交
    function submit() {
      httpRequest.post_syncInvoice($scope.submit).then((res) => {
        if (res.data.success) {
          logger.logSuccess('生成申报任务成功')
          $uibModalInstance.close()
        }
      })
    }
  }
}
buildTaskModalCtr.$inject = [
  '$scope',
  '$uibModalInstance',
  'selectedRows',
  'logger',
  'allApplyPeriod',
  'httpRequest',
]



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/buildTaskModalCtr.js